import dayjs from 'dayjs';
import type { Dayjs, ManipulateType } from 'dayjs';

import type {
  VTimeSeriesChartDataSet,
  VTimeSeriesChartDataTemplate,
} from './type';

export const makeFilledData = <T extends VTimeSeriesChartDataTemplate>(
  data: T,
  dateRange: [DateLike, DateLike],
  datePeriodUnit: ManipulateType,
) => {
  const normalziedDateRange = dateRange.map(v => dayjs(v)) as [Dayjs, Dayjs];
  const startDate = normalziedDateRange[0];
  const endDate = normalziedDateRange[1];
  const dateList = [] as Dayjs[];
  let currentDate = startDate;

  while (currentDate.isBefore(endDate)) {
    dateList.push(currentDate);
    currentDate = currentDate.add(1, datePeriodUnit);
  }

  dateList.push(endDate);

  const dataTimestampMapByLabelName = Object.fromEntries(
    Object.entries(data).map(([labelName, v]) => [
      labelName,
      new Map(v.map(v => [v.timestamp, v.value] as const)),
    ]),
  );

  const filledData = {} as Dictionary<VTimeSeriesChartDataSet[]>;

  Object.keys(data).forEach(labelName => {
    const result = dateList.map(date => {
      const timestamp = date.utc().format();

      if (dataTimestampMapByLabelName[labelName].has(timestamp)) {
        return {
          timestamp,
          value: dataTimestampMapByLabelName[labelName].get(timestamp)!,
        };
      }

      return {
        timestamp,
        value: 0,
      };
    });

    filledData[labelName] = result;
  });

  return filledData as T;
};
